import { useSession as nextAuthUseSession } from 'next-auth/react'
import { useEffect } from 'react'
import { signOut } from '@/lib/utils'

export const useSession = () => {
  const { status, data: session, update: updateSession } = nextAuthUseSession()

  useEffect(() => {
    // Force sign out upon session expiry
    if (session && session.isExpired) signOut()
  }, [session])

  return {
    isLoadingSession: status === 'loading',
    isSignedIn: status === 'authenticated',
    session,
    updateSession,
  }
}
